export interface NavItem {
  href: string
  title: string
  iconSlug: string
  // Shown on the /mais overflow page's descriptive blocks. Optional because
  // the sidebar rail and bottom nav render items without it.
  description?: string
}

export const rankedNavItems: NavItem[] = [
  { href: '/jornadas', title: 'Aprender', iconSlug: 'home' },
  { href: '/missoes', title: 'Missões', iconSlug: 'missions' },
  {
    href: '/passe',
    title: 'Passe',
    iconSlug: 'pass',
    description:
      'Complete objetivos, avance na trilha e resgate recompensas exclusivas a cada marco.'
  },
  { href: '/ranking', title: 'Ranking', iconSlug: 'ranking' },
  { href: '/loja', title: 'Loja', iconSlug: 'store' },
  {
    href: '/biblioteca',
    title: 'Biblioteca',
    iconSlug: 'library',
    description:
      'Acesse documentos e materiais de apoio para aprofundar seus estudos.'
  },
  {
    href: '/quizzes',
    title: 'Quizzes',
    iconSlug: 'quizzes',
    description:
      'Responda avaliações rápidas com perguntas sorteadas e ganhe pontos por acerto.'
  },
  {
    href: '/avaliacoes',
    title: 'Avaliações',
    iconSlug: 'evaluations',
    description:
      'Responda questionários e sondagens da sua escola e ganhe pontos por concluir.'
  },
  {
    href: '/campanhas',
    title: 'Campanhas',
    iconSlug: 'campaigns',
    description:
      'Participe de campanhas especiais da sua escola ou turma e ganhe recompensas por tempo limitado.'
  },
  {
    href: '/novidades',
    title: 'Novidades',
    iconSlug: 'news',
    description:
      'Fique por dentro dos últimos anúncios, atualizações e conteúdos novos da plataforma.'
  },
  {
    href: '/grupos',
    title: 'Meus grupos',
    iconSlug: 'groups',
    description:
      'Veja os grupos que você participa, acompanhe colegas e conquistas em equipe.'
  },
  {
    href: '/titulos',
    title: 'Títulos',
    iconSlug: 'titles',
    description:
      'Desbloqueie títulos ao completar desafios e mostre suas conquistas no perfil.'
  },
  {
    href: '/amigos',
    title: 'Amigos',
    iconSlug: 'friends',
    description:
      'Adicione colegas, acompanhe o progresso deles e suba juntos no ranking.'
  },
  {
    href: '/central-de-ajuda',
    title: 'Central de Ajuda',
    iconSlug: 'help',
    description:
      'Tire dúvidas, veja perguntas frequentes e encontre suporte pra usar a plataforma.'
  },
  {
    href: '/meus-dados',
    title: 'Meus Dados',
    iconSlug: 'user',
    description:
      'Veja e exporte seus dados pessoais (LGPD) em JSON ou PDF.'
  }
]

export const MOBILE_VISIBLE_COUNT = 5

export const maisNavItem: NavItem = {
  href: '/mais',
  title: 'Mais',
  iconSlug: 'more'
}
